import { buildTranslate } from 'locales'
import { Fields as RedeemTemplate } from 'models/RedeemTemplate'
import React from 'react'
import Card from './Card'

type PropsT = {
  template: RedeemTemplate
}

const t = buildTranslate('redeem_manager.detail.cards.maximum_discount')

const MaximumDiscountCard = ({ template }: PropsT) => {
  const hasMaximum =
    typeof template.maximum === 'number' && template.maximum > 0
  return (
    <Card title={t('title')} isActive={hasMaximum}>
      <p className="grey-70">
        {hasMaximum ? t('value', { amount: template.maximum }) : t('not_set')}
      </p>
    </Card>
  )
}

export default MaximumDiscountCard
